import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './nav_dropdown_content.module.scss';

export const NavDropdownContent: FC<{ className?: string }> = ({
  children,
  className,
}) => <div className={classNames(styles.container, className)}>{children}</div>;
